import { PopupMenu, PopupMenuItemShape } from '~components/generic/popup-menu/PopupMenu';
import { DeleteIcon, RenameIcon, UserAddIcon } from '~components/icons';

export type ContextMenuProps = {
  onClose: () => void;
  onClickRename: () => void;
  onClickAddUsers: () => void;
  onClickDelete: () => void;
  pageX: number;
  pageY: number;
  groupId: string;
};

export const ContextMenu = (props: ContextMenuProps) => {
  const items: PopupMenuItemShape[] = [
    {
      id: 'addUser',
      label: 'btnEditUsergroupAddUsers',
      onClick: props.onClickAddUsers,
      icon: <UserAddIcon />,
    },
    {
      id: 'rename',
      label: 'btnEditUsergroupRename',
      onClick: props.onClickRename,
      icon: <RenameIcon />,
    },
    {
      id: 'delete',
      label: 'btnEditUsergroupDelete',
      onClick: props.onClickDelete,
      icon: <DeleteIcon />,
    },
  ];

  return <PopupMenu onClose={props.onClose} items={items} x={props.pageX} y={props.pageY} />;
};
